/**
 * Base URL for the GCP Security Command Center remediation documentation.
 *
 * @see {@link https://cloud.google.com/security-command-center/docs/how-to-remediate-security-health-analytics-findings}
 */
export const SCC_REMEDIATION_BASE =
    "https://cloud.google.com/security-command-center/docs/how-to-remediate-security-health-analytics-findings";

/**
 * Base URL for the Google Cloud Console project dashboard.
 *
 * @see {@link https://console.cloud.google.com/home/dashboard}
 */
export const GCP_CONSOLE_BASE =
    "https://console.cloud.google.com/home/dashboard";

/**
 * Primary FQDN-scoped catalog annotation for GCP project associations.
 *
 * @remarks
 * This is the canonical annotation key. Prefer this over any alias.
 *
 * @example
 * ```yaml
 * metadata:
 *   annotations:
 *     google.com/gcp.projects: my-project-id
 * ```
 */
export const GCP_PROJECT_ANNOTATION_PRIMARY = "google.com/gcp.projects";

/**
 * Legacy annotation aliases retained for backwards compatibility.
 *
 * @remarks
 * These aliases are supported during the migration period only.
 * New catalog entries should use {@link GCP_PROJECT_ANNOTATION_PRIMARY}.
 */
export const GCP_PROJECT_ANNOTATION_ALIASES = [
    "gcp/projects",
    "gcp.com/projects",
] as const;
